/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "common": {
        "nested": {
          "RGBAColor": {
            "fields": {
              "r": {
                "type": "double",
                "id": 1,
                "rule": "optional"
              },
              "g": {
                "type": "double",
                "id": 2,
                "rule": "optional"
              },
              "b": {
                "type": "double",
                "id": 3,
                "rule": "optional"
              },
              "a": {
                "type": "double",
                "id": 4,
                "rule": "optional",
                "options": {
                  "default": 255.0
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.common?.nested?.RGBAColor) {
  $root.addJSON(jsonData);
}

/**
 * This represents an RGB color in the SRGB color space. Values are 0-255
 *
 * SOURCE RGBAColor @ squareup/common/colors.proto at 8:1
 */
export const RGBAColor = $root.lookupType('squareup.common.RGBAColor');
fixType(RGBAColor);
Builder.createAndAttachToType(RGBAColor);